// Module
var code = "<template>\n    <a href=\"#\" click.trigger=\"toggleFavorite()\">\n        <i class=\"bx bx${exists ? 's' : ''}-star bx-sm text-warning\"></i>\n    </a>\n</template>";
// Exports
export default code;